var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.99953C0 5.74367 0.111607 5.48768 0.334821 5.29269L6.04911 0.292953C6.49554 -0.0976512 7.21875 -0.0976512 7.66518 0.292953C8.11161 0.683558 8.11161 1.31634 7.66518 1.70694L2.75714 5.99953L7.66429 10.2931C8.11071 10.6837 8.11071 11.3164 7.66429 11.707C7.21786 12.0977 6.49464 12.0977 6.04821 11.707L0.333929 6.70731C0.110714 6.512 0 6.25577 0 5.99953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileVector3);
export default __webpack_public_path__ + "static/media/profile-Vector3.be0f06e0e3641002abe0e42b0b0945ad.svg";
export { ForwardRef as ReactComponent };